// src/components/Hero.js
import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-overlay"></div>
      <div className="container hero-content">
        <h1>BUILDING THE FUTURE, INTELLIGENTLY.</h1>
        <p>Bridging physical infrastructure with advanced AI, IoT, and software solutions for a smarter world.</p>
        <a href="/solutions" className="btn btn-gradient">Explore Our Solutions</a>
      </div>
    </section>
  );
};

export default Hero;